import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { HttpClient } from "../../../api/httpClient";
import { DEFAULT_ENTITY_STATE } from "../../utils";

const baseName = "users";

const initialState = {
  expenses: DEFAULT_ENTITY_STATE,
  approver: DEFAULT_ENTITY_STATE,
  financial: DEFAULT_ENTITY_STATE,
  admin: DEFAULT_ENTITY_STATE,
  director: DEFAULT_ENTITY_STATE,
  insights: DEFAULT_ENTITY_STATE,
};

export const getUsers = createAsyncThunk(
  `${baseName}/getUsers`,
  async (role) => {
    const res = await HttpClient.get({ url: "/users", params: { role } });
    return res?.data;
  }
);

export const usersSlice = createSlice({
  name: baseName,
  initialState,
  reducers: {
    setupUsers(state, { payload }) {
      //CONFIGURAR ENTRADA DE DADOS
      const { data, role } = payload || {};
      if (!state[role]) return;
      //CONFIGURAR ENTRADA DE DADOS
      state[role].data =
        data?.map((item) => ({ ...item, id: item?._id })) || [];
    },

    //ADM ACTIONS
    addUser(state, { payload }) {
      state.admin.data.push(payload);
    },
    updateUser(state, { payload }) {
      const { id, changes } = payload;
      const index = state.admin.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.admin.data[index] = {
          ...state.admin.data[index],
          ...changes,
        };
      }
    },
    removeUser(state, { payload }) {
      state.admin.data = [
        ...state.admin.data?.filter((item) => item?.id !== payload),
      ];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state, action) => {
        const role = action.meta.arg || "expenses";
        state[role].status = "loading";
        state[role].error = null;
      })
      .addCase(getUsers.rejected, (state, action) => {
        const role = action.meta.arg || "expenses";
        state[role].status = "failed";
        state[role].error = action.error.message || null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        const role = action.meta.arg || "expenses";
        state[role].status = "succeeded";
        state[role].error = null;

        //Dados API
        const data = action.payload || [];
        usersSlice.caseReducers.setupUsers(state, {
          payload: {
            data: data || [],
            role,
          },
        });
      });
  },
});

export const { addUser, removeUser, setupUsers, updateUser } =
  usersSlice.actions;

export default usersSlice.reducer;

export const selectUsersByRole = createSelector(
  [(state) => state.users, (state, role) => role],
  (usersState = {}, role = "") => {
    const prevData = usersState[role] || DEFAULT_ENTITY_STATE;
    return {
      ...prevData,
      total: prevData?.data?.length || 0,
    };
  }
);

export const selectUserById = createSelector(
  [selectUsersByRole, (state, role, userId) => userId],
  (usersState = {}, userId = "") => {
    return usersState?.data?.find((item) => item?.id === userId) || {};
  }
);
